var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndrawWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 813.04,
    height: 683.381,
    viewBox: "0 0 813.04 683.381",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-553.48 -178.918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.447,75.484a66.379,66.379,0,1,1,86.266,63.344l-9.9,7.974,17.767,62.185-20.7,14.646-65.417-54.514s14.132-18,21.711-38.3a66.307,66.307,0,0,1-29.728-55.338Z",
    transform: "translate(553.479 250.932)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.989,245.556,423.431,410.821l-48.1-33.379,56.676-144.191c-4.943-9.154-6.171-21.185-2.417-33.078,6.569-20.809,25.855-33.271,43.076-27.835s25.857,26.712,19.288,47.521c-3.754,11.893-11.668,21.038-20.97,25.7Z",
    transform: "translate(553.479 250.932)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 171.552,
    height: 199.807,
    transform: "translate(694.197 561.744)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.186,435.608,91.274,553.849l-2.318,56.536H376.665L321.177,435.608Z",
    transform: "translate(553.479 250.932)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.948,611.367H32.511a2.539,2.539,0,0,1,0-5.023H431.948a2.533,2.533,0,0,1,0,5.023Z",
    transform: "translate(553.479 250.932)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.3,151.484l-40.781,93.13,4.035,160.059H299.389l4.327-169.834-51.172-78.874Z",
    transform: "translate(553.479 250.932)",
    fill: "#2FBB69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.371,188.543s-11.939,342.471-44,398.987c0,0,44.3,7.72,55.57-8.247s54.727-122.271,55.2-145.813,14.086-282.1,14.086-282.1l-80.858,37.173Z",
    transform: "translate(553.479 250.932)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.944,165.377l3.6-9.411,91.407,36.3S339.686,534.514,376.69,569.1c0,0-61.82-2.949-63.873-4.365s-46.934-178.392-46.934-178.392,21.395-81.986,23.046-116.993-39.986-103.97-39.986-103.97Z",
    transform: "translate(553.479 250.932)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.758,198.956l23.193-6.691,53.329,108,22.855-59.155L476.6,257.247s-25.666,166.562-64.469,157.6-91.375-100.428-91.375-100.428V198.956Z",
    transform: "translate(553.479 250.932)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.13,528.775,14.3,415.627l35.781-31.48L123.22,507.293c9.486,1.582,18.967,7.508,25.522,16.993,11.468,16.6,9.631,37.744-4.1,47.235S110.468,575.253,99,558.657c-6.554-9.485-8.744-20.449-6.87-29.882Z",
    transform: "translate(553.479 250.932)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.186,198.091l-13.815-9.549L3.361,402s-9.173,12.872,2.792,33.611S79.545,519.86,79.545,519.86l48.4-27.337-49.3-91.87,46.466-80.374,5.071-122.187Z",
    transform: "translate(553.479 250.932)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.431,19.483c14.844,5.216,23.337,8.2,31.118,15.7,13.141,12.661,15.311,29.58,17.325,45.3,1.577,12.3,3.616,28.2-3.6,46.368-2.458,6.2-11.737,38.016-34.555,41.506-4.481.686-15,.865-11.97-1.374,28.067-20.72,37.4-37.423,36.419-69.358-.611-19.844-30.931-41.267-48.933-45.117a30.661,30.661,0,0,0-24.911,5.8c-15.131,12.422-14.487,63.79-30.443,74.527-6.562,4.417-2.191-26.67-6.813-21.629-9.122,9.946-3.272,25.168-1.631,30.979,7.776,27.518,15.922,7.168,23.509,30.666,4.084,12.633-31.941,25.759-50.952,29.34-18.743,3.531-26.822,13.752-16.974,5.566-26.494-11.119,28.6-46.627,31.075-56.691,3.539-14.382-11.156-20.514-14.1-43.2-2.013-15.514-3.428-37.7,2.054-51.925,5.172-13.431,9.664-25.088,21.416-35.659C282.294,17.747,305.079.489,329.24,0c11.123-.223,19.3,14.941,32.192,19.474h0Z",
    transform: "translate(462.839 217.703)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.316,542.2c-.126,0-.252,0-.38-.009a9.051,9.051,0,0,1-7.429-5.025,118.731,118.731,0,0,0-21.971-28.3c-5.156-4.9-10.544-9.459-15.755-13.867-13.442-11.367-26.1-22.073-33.129-36.866-15.321-32.257,2.722-77.185,28.5-97.334,28.912-22.6,66.94-26.143,103.729-26.607q5.735-.072,11.477-.072h0a925.618,925.618,0,0,1,197.621,21.49c21.677,4.756,44.368,10.583,62.6,24.724,18.126,14.057,29.143,36.193,28.068,56.4-1.569,29.493-27.858,51.531-51.8,57.292-22.817,5.487-46.52,1.779-71.614-2.148-5.54-.866-11.268-1.763-16.932-2.542-61.56-8.462-177.2,17.621-182.1,18.735l-4.854,1.105L569.519,538a8.621,8.621,0,0,1-7.2,4.208Z",
    transform: "translate(450.801 -107.199)",
    fill: "#2FBB69"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-377.562 -54.635) rotate(-17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,15.637a1,1,0,0,1-1-1V9a1,1,0,0,1,2,0v5.637A1,1,0,0,1,12,15.637Z",
    transform: "translate(1168 614.363)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,1.668a2.93,2.93,0,0,1,2.492,1.4l0,0L22.6,16.612l.008.014A2.914,2.914,0,0,1,20.119,21H3.882a2.914,2.914,0,0,1-2.491-4.371l.008-.014L9.489,3.1l.019-.032A2.93,2.93,0,0,1,12,1.668Zm.78,2.438A.914.914,0,0,0,11.23,4.09l-.009.015L3.12,17.631A.914.914,0,0,0,3.9,19H20.1a.914.914,0,0,0,.78-1.365Z",
    transform: "translate(1168 615)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.01,17H12a1,1,0,0,1,0-2h.01a1,1,0,0,1,0,2Z",
    transform: "translate(1168 616)",
    fill: "#090814"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(454.737 -914.381) rotate(28)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1169.002 616.668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.394,18.642A1.394,1.394,0,0,1,11,17.249V9.394a1.394,1.394,0,0,1,2.787,0v7.855A1.394,1.394,0,0,1,12.394,18.642Z",
    transform: "translate(2.933 -0.063)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.329,1.668A4.084,4.084,0,0,1,19.8,3.624l0,.006L31.1,22.494l.012.02A4.061,4.061,0,0,1,27.642,28.6H5.015a4.061,4.061,0,0,1-3.471-6.091l.011-.019L12.83,3.669l.026-.044A4.084,4.084,0,0,1,16.329,1.668Zm1.088,3.4a1.274,1.274,0,0,0-2.161-.023l-.012.021L3.953,23.913a1.274,1.274,0,0,0,1.087,1.9H27.617a1.274,1.274,0,0,0,1.087-1.9Z",
    transform: "translate(-1.002 -1.668)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.408,17.787h-.014a1.394,1.394,0,0,1,0-2.787h.014a1.394,1.394,0,0,1,0,2.787Z",
    transform: "translate(2.933 4.973)",
    fill: "#090814"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-23.074 -45.527) rotate(-7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1169.002 616.668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.063,16.117A1.063,1.063,0,0,1,11,15.054V9.063a1.063,1.063,0,0,1,2.126,0v5.991A1.063,1.063,0,0,1,12.063,16.117Z",
    transform: "translate(-0.373 -1.946)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.692,1.668A3.115,3.115,0,0,1,15.341,3.16l0,0L23.96,17.553l.009.015a3.1,3.1,0,0,1-2.648,4.644H4.063a3.1,3.1,0,0,1-2.648-4.646l.009-.015,8.6-14.358.02-.034A3.115,3.115,0,0,1,12.692,1.668Zm.83,2.592a.972.972,0,0,0-1.648-.017l-.009.016L3.253,18.635a.972.972,0,0,0,.829,1.451H21.3a.972.972,0,0,0,.829-1.45Z",
    transform: "translate(-1.002 -1.668)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.074,17.126h-.011a1.063,1.063,0,1,1,0-2.126h.011a1.063,1.063,0,1,1,0,2.126Z",
    transform: "translate(-0.373 0.234)",
    fill: "#090814"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-52.001 -343.001)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1169.002 616.668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.346,33.556A3.346,3.346,0,0,1,11,30.209V11.346a3.346,3.346,0,0,1,6.693,0V30.209A3.346,3.346,0,0,1,14.346,33.556Z",
    transform: "translate(22.457 11.059)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.806,1.668a9.806,9.806,0,0,1,8.34,4.7l.009.015,27.126,45.3.028.048a9.751,9.751,0,0,1-8.335,14.622H10.639A9.751,9.751,0,0,1,2.3,51.72l.027-.046L29.4,6.473q.03-.054.062-.107A9.806,9.806,0,0,1,37.806,1.668Zm2.612,8.16a3.059,3.059,0,0,0-5.189-.055l-.03.051L8.089,55.086a3.059,3.059,0,0,0,2.61,4.569H64.913a3.059,3.059,0,0,0,2.609-4.566Z",
    transform: "translate(-1.002 -1.668)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.38,21.693h-.033a3.346,3.346,0,0,1,0-6.693h.033a3.346,3.346,0,1,1,0,6.693Z",
    transform: "translate(22.457 32.961)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawWarning);
export default __webpack_public_path__ + "static/media/undraw-warning.de06869cadf6a11b68aec5393e8ffb0f.svg";
export { ForwardRef as ReactComponent };